module.exports = __webpack_public_path__ + "static/media/signature.b90e4269.png";